import React from "react";
import "./Contact.css";
import emailjs from "emailjs-com";

const Contact = () => {
  function sendEmail(e) {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_xu516ci",
        "template_lof30wf",
        e.target,
        "user_Ce4YbihGHm4qSZwxY06Fv"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  }

  return (
    <div className="contact-section d-flex align-items-center">
      <div className="container">
        <div className="row">
          <div className="col-md-8 offset-md-2">
            <form onSubmit={sendEmail} className="my-contact-form">
              <h2 className="text-center pb-5">Contact With Me</h2>
              <div class="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Name"
                  name="name"
                />
              </div>
              <div className="mb-3">
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email"
                  name="email"
                />
              </div>
              <div class="mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Subject"
                  name="subject"
                />
              </div>
              <div className="mb-3">
                <textarea
                  className="form-control"
                  placeholder="Your message..."
                  rows="3"
                  name="message"
                ></textarea>
              </div>
              <input
                type="submit"
                className="form-control"
                value="Send Message"
              />
            </form>
            <p className="p-4">
              <b>Email goes to:</b>{" "}
              <span className="my-gmail">showkatjubayer@gmail.com</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
